<template>
  <AuthWrapper>
    <a-form id="form-forgot-password" layout="vertical" class="login-form" :form="formResetPassword" @submit="onSubmitForm">
      <div class="forgot-password-title">
        <span class="forgot-password-title__text">Reset Password</span>
      </div>

      <a-alert type="info">
        <template slot="message">
          Enter the code
        </template>
        <template slot="description">
          The code will be expired in 3 hours.
          <a href="javascript:void(0)" @click.prevent="onResendCode()">
            <u>Resend</u>
          </a>
        </template>
      </a-alert>
      <br />

      <a-form-item label="Reset code">
        <a-input
          v-decorator="[
            'resetCode',
            {
              initialValue: resetCode,
              rules: [
                {
                  required: true,
                  message: 'Please input Reset code',
                },
              ],
            },
          ]"
          placeholder="Reset code"
          autocomplete="off"
        />
      </a-form-item>

      <a-form-item label="New Password">
        <a-input-password
          v-decorator="[
            'password',
            {
              rules: [
                {
                  required: true,
                  message: 'Please input your password.',
                },
                { validator: validateToNextPassword },
              ],
            },
          ]"
          placeholder="Password"
          autocomplete="new-password"
        />
      </a-form-item>

      <a-form-item label="Confirm password" class="mb-0">
        <a-input-password
          v-decorator="[
            'confirmPassword',
            {
              rules: [
                {
                  required: true,
                  message: 'Please confirm your password.',
                },
                { validator: compareToFirstPassword },
              ],
            },
          ]"
          placeholder="Confirm Password"
          autocomplete="new-password"
          @blur="handleConfirmBlur"
        />
      </a-form-item>

      <a-form-item class="mb-0">
        <a-button :disabled="isFormInvalid()" type="primary" html-type="submit" size="large" class="btn-form">
          Update
        </a-button>
        <a href="javascript:void(0);" class="login-again-action" @click.prevent="backToSignInPage()">
          Back to sign in
        </a>
      </a-form-item>
    </a-form>
  </AuthWrapper>
</template>

<script>
  import AuthWrapper from './AuthWrapper';
  import AuthenticationService from '../services/authentication.service';

  export default {
    name: 'ResetPassword',
    components: {
      AuthWrapper,
    },
    data() {
      return {
        resetCode: '',
        isCheckingFromServer: false,
        confirmDirty: false,
      };
    },
    beforeCreate() {
      this.formResetPassword = this.$form.createForm(this, {
        name: 'reset-form',
      });
    },
    beforeMount() {
      this.resetCode = decodeURIComponent(this.$route.query.code || '');
    },
    methods: {
      handleConfirmBlur(e) {
        const value = e.target.value;
        this.confirmDirty = this.confirmDirty || !!value;
      },
      compareToFirstPassword(rule, value, callback) {
        const form = this.formResetPassword;
        if (value && value !== form.getFieldValue('password')) {
          callback('Two passwords that you enter is inconsistent!');
        } else {
          callback();
        }
      },
      validateToNextPassword(rule, value, callback) {
        const form = this.formResetPassword;
        if (value && this.confirmDirty) {
          form.validateFields(['confirmPassword'], { force: true });
        }
        callback();
      },
      isFormInvalid() {
        if (this.isCheckingFromServer) {
          return true;
        }
        if (!this.formResetPassword) {
          return true;
        }
        return !this.formResetPassword.getFieldValue('resetCode')
            || !this.formResetPassword.getFieldValue('password')
            || !this.formResetPassword.getFieldValue('confirmPassword')
            || !!this.formResetPassword.getFieldError('resetCode')
            || !!this.formResetPassword.getFieldError('password')
            || !!this.formResetPassword.getFieldError('confirmPassword')
        ;
      },
      onSubmitForm(e) {
        e.preventDefault();
        this.formResetPassword.validateFields((err, formValue) => {
          if (!err) {
            const { resetCode, password } = formValue;
            this.handleResetPassword(resetCode, password);
          }
        });
      },
      async handleResetPassword(resetCode, password) {
        this.isCheckingFromServer = true;
        try {
          const requestBody = {
            code: resetCode,
            new_password: password,
          };
          const resetResponse = await AuthenticationService.resetPassword(requestBody);
          this.$showSuccessMessage(resetResponse);
          this.$router.push('/login');
        } catch (error) {
          this.$showMultiErrorMessage(error.messages || []);
        } finally {
          this.isCheckingFromServer = false;
        }
      },
      onResendCode() {
        this.$router.push('/forgot-password');
      },
      backToSignInPage() {
        this.$router.push('/login');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-form {
    display: block;
    width: 100%;
    margin-top: 27px;
  }
  .forgot-password-title {
    margin-bottom: 20px;
    margin-top: 20px;

    &__text {
      color: $pr;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .notification {
    text-align: center;
    font-size: 13px;
    margin-top: 20px;
  }
  .login-again-action {
    margin-top: 10px;
    display: block;
    text-align: center;
  }
</style>
